import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { FileDisplaySize } from '@freelancer/ui/file-display';
import { HeadingSize, HeadingType } from '@freelancer/ui/heading';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import { Margin } from '@freelancer/ui/margin';
import {
  RibbonColor,
  RibbonOrientation,
  RibbonPlacement,
} from '@freelancer/ui/ribbon';
import { Tab } from '@freelancer/ui/tabs';
import {
  FontColor,
  FontSize,
  FontWeight,
  TextTransform,
} from '@freelancer/ui/text';
import { AvatarSize } from '@freelancer/ui/user-avatar';

@Component({
  selector: 'app-preview-modal',
  template: `
    <fl-link class="EntryPreview-navigator EntryPreview-navigator--previous">
      <fl-icon
        [name]="'ui-chevron-left'"
        [color]="IconColor.LIGHT"
        [size]="IconSize.XLARGE"
      ></fl-icon>
    </fl-link>

    <fl-link class="EntryPreview-navigator EntryPreview-navigator--next">
      <fl-icon
        [name]="'ui-chevron-right'"
        [color]="IconColor.LIGHT"
        [size]="IconSize.XLARGE"
      ></fl-icon>
    </fl-link>

    <fl-grid class="EntryPreview-layout">
      <fl-col class="EntryPreview-layout--primary" [col]="8">
        <fl-bit class="EntryPreview-header">
          <fl-bit
            class="EntryPreview-header-content"
            [flMarginBottom]="Margin.XXXSMALL"
          >
            <fl-bit
              class="EntryPreview-header-content-title"
              [flMarginRight]="Margin.SMALL"
            >
              <fl-heading
                i18n="Entry number header"
                [size]="HeadingSize.SMALL"
                [headingType]="HeadingType.H1"
                [flMarginRight]="Margin.XXSMALL"
              >
                Entry #{{ entryNumber }}
              </fl-heading>
              <fl-icon
                [name]="'ui-lock-closed'"
                [size]="IconSize.SMALL"
                [color]="IconColor.INHERIT"
              ></fl-icon>
            </fl-bit>

            <fl-rating [control]="ratingControl" [hideValue]="true"></fl-rating>
          </fl-bit>

          <fl-bit class="EntryPreview-header-cta">
            <fl-bit>
              <fl-text
                i18n="Entry attachments text"
                [size]="FontSize.XSMALL"
                [color]="FontColor.MID"
                [textTransform]="TextTransform.UPPERCASE"
                [flMarginBottom]="Margin.XXXSMALL"
              >
                Attachments
              </fl-text>
              <!-- TODO: Replace with film strip image slider T79559 -->
              <fl-bit class="EntryPreview-header-cta-thumbnails">
                <fl-file-display
                  *ngFor="let thumbnail of fileThumbnails"
                  [src]="thumbnail.src"
                  [alt]="thumbnail.title"
                  [size]="FileDisplaySize.XSMALL"
                  [flMarginRight]="Margin.XXSMALL"
                ></fl-file-display>
              </fl-bit>
            </fl-bit>

            <fl-bit class="EntryPreview-header-cta-group" *ngIf="true">
              <fl-button
                class="EntryPreview-header-cta-button"
                i18n="Entry reject button"
                [color]="ButtonColor.DEFAULT"
                [size]="ButtonSize.SMALL"
                [flMarginRight]="Margin.SMALL"
              >
                Reject
              </fl-button>
              <fl-button
                class="EntryPreview-header-cta-button"
                i18n="Entry award button"
                [color]="ButtonColor.SUCCESS"
                [size]="ButtonSize.SMALL"
              >
                Award
              </fl-button>
            </fl-bit>

            <fl-button
              class="EntryPreview-header-cta-button"
              *ngIf="false"
              i18n="Entry view handover button"
              [color]="ButtonColor.DEFAULT"
              [size]="ButtonSize.SMALL"
            >
              Reconsider
            </fl-button>

            <fl-button
              class="EntryPreview-header-cta-button"
              *ngIf="false"
              i18n="Entry view handover button"
              [color]="ButtonColor.DEFAULT"
              [size]="ButtonSize.SMALL"
            >
              View Handover
            </fl-button>

            <fl-button
              class="EntryPreview-header-cta-button"
              *ngIf="false"
              i18n="Entry buy button"
              [color]="ButtonColor.DEFAULT"
              [size]="ButtonSize.SMALL"
            >
              Buy
            </fl-button>
          </fl-bit>
        </fl-bit>
        <fl-bit class="EntryPreview-file-container">
          <fl-bit class="EntryPreview-file-overlay" *ngIf="false">
            <fl-text
              class="EntryPreview-file-overlay-text"
              i18n="Entry rejected text"
              [color]="FontColor.LIGHT"
              [weight]="FontWeight.BOLD"
            >
              Rejected
            </fl-text>
          </fl-bit>
          <fl-ribbon
            class="Card-ribbon"
            *ngIf="false"
            iconLabel="Awarded"
            [color]="RibbonColor.SECONDARY"
            [icon]="'ui-trophy'"
            [orientation]="RibbonOrientation.VERTICAL"
            [placement]="RibbonPlacement.LEFT"
          ></fl-ribbon>
          <fl-ribbon
            class="Card-ribbon"
            *ngIf="false"
            iconLabel="Bought"
            [color]="RibbonColor.SECONDARY_DARK"
            [icon]="'ui-bought-medal'"
            [orientation]="RibbonOrientation.VERTICAL"
            [placement]="RibbonPlacement.LEFT"
          ></fl-ribbon>
          <fl-ribbon
            class="Card-ribbon"
            *ngIf="false"
            iconLabel="Highlighted"
            i18n="Highlighted text"
            [color]="RibbonColor.SECONDARY"
            [placement]="RibbonPlacement.LEFT"
          >
            Highlighted
          </fl-ribbon>
          <fl-bit class="EntryPreview-file-content">
            <fl-picture
              *ngIf="true"
              alt="imageAlt"
              [src]="imageUrl"
              [externalSrc]="true"
              [boundedWidth]="true"
            ></fl-picture>
            <fl-video
              class="EntryPreview-file-video"
              *ngIf="false"
              [src]="videoUrl"
            ></fl-video>
          </fl-bit>
        </fl-bit>
      </fl-col>
      <fl-col class="EntryPreview-layout--secondary" [col]="4">
        <fl-bit class="EntryPreview-details">
          <fl-bit
            class="EntryPreview-details-user"
            [flMarginBottom]="Margin.SMALL"
          >
            <fl-user-avatar
              [users]="user"
              [size]="AvatarSize.LARGE"
              [flMarginRight]="Margin.XSMALL"
            ></fl-user-avatar>
            <fl-bit>
              <fl-bit
                class="EntryPreview-details-user-info"
                [flMarginBottom]="Margin.XXSMALL"
              >
                <fl-flag
                  [country]="country"
                  [flMarginRight]="Margin.XXSMALL"
                ></fl-flag>
                <fl-text [weight]="FontWeight.BOLD"> {{ publicName }} </fl-text>
              </fl-bit>
              <fl-button
                i18n="Chat button"
                [color]="ButtonColor.DEFAULT"
                [size]="ButtonSize.MINI"
              >
                <fl-online-indicator
                  [isOnline]="isOnline"
                  [flMarginRight]="Margin.XXXSMALL"
                ></fl-online-indicator>
                Chat
              </fl-button>
            </fl-bit>
          </fl-bit>

          <fl-text
            class="EntryPreview-details-title"
            [weight]="FontWeight.BOLD"
            [flMarginBottom]="Margin.XSMALL"
          >
            {{ title }}
          </fl-text>
          <fl-text
            class="EntryPreview-details-description"
            [readMore]="DESCRIPTION_LIMIT"
            [flMarginBottom]="Margin.SMALL"
          >
            {{ description }}
          </fl-text>

          <fl-bit class="EntryPreview-details-feedback">
            <fl-icon
              [name]="'ui-thumbs-up'"
              [color]="liked ? IconColor.PRIMARY : IconColor.MID"
              [size]="IconSize.SMALL"
              [flMarginRight]="Margin.XXXSMALL"
            ></fl-icon>
            <fl-text [flMarginRight]="Margin.XSMALL">
              {{ likeCount }}
            </fl-text>
            <fl-icon
              [name]="'ui-community'"
              [color]="IconColor.MID"
              [size]="IconSize.SMALL"
              [flMarginRight]="Margin.XXXSMALL"
            ></fl-icon>
            <fl-text> {{ commentCount }} </fl-text>
          </fl-bit>
        </fl-bit>

        <fl-bit class="EntryPreview-tab" [flMarginBottom]="Margin.SMALL">
          <fl-tabs [tabs]="tabs"> </fl-tabs>
        </fl-bit>
      </fl-col>
    </fl-grid>
  `,
  styleUrls: ['./preview-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewModalComponent {
  AvatarSize = AvatarSize;
  ButtonColor = ButtonColor;
  ButtonSize = ButtonSize;
  FileDisplaySize = FileDisplaySize;
  FontColor = FontColor;
  FontSize = FontSize;
  FontWeight = FontWeight;
  HeadingSize = HeadingSize;
  HeadingType = HeadingType;
  IconColor = IconColor;
  IconSize = IconSize;
  Margin = Margin;
  RibbonColor = RibbonColor;
  RibbonOrientation = RibbonOrientation;
  RibbonPlacement = RibbonPlacement;
  TextTransform = TextTransform;

  readonly DESCRIPTION_LIMIT = 200;

  tabs: ReadonlyArray<Tab> = [
    {
      title: 'Comments',
      selected: true,
    },
  ];

  /**
   * Placeholder variables.
   * TODO: Replace variables with dynamic data -- hooked from the backend.
   */
  entryNumber = 3;
  ratingControl = new FormControl();
  fileThumbnails: ReadonlyArray<any> = [
    {
      title: 'Test Entry Thumbnail',
      src: '/assets/image-thumbnail-placeholder.svg',
    },
    {
      title: 'Test Entry Thumbnail',
      src: '/assets/image-thumbnail-placeholder.svg',
    },
  ];

  imageAlt = 'This is my contest title';
  imageUrl = 'https://images.pexels.com/photos/459225/pexels-photo-459225.jpeg';
  videoUrl =
    'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4';

  user = {
    avatar: 'http://i.pravatar.cc/32',
    id: 4,
    username: 'bob',
  };
  country = 'au';
  publicName = 'Arend P.';
  isOnline = true;
  title = 'This is my contest title';
  description =
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam aliquet eget nunc sit amet egestas. Name tempus lacus ex, ac viverra enim sollicitudin vel. Vestibulum sit amet nulla ac metus interdum accumsan eget sed orci. Nulla volutpat, ligula nec tincidunt cursus, est lorem dapibus dolor, sit amet imperdiet ex turpis vestibulum ante. Suspendisse eros lacus, auctor et ipsum eget, finibus varius turpis. Aliquam non purus quis mi ultricies dapibus. Duis pharetra ante in fermentum facilisis. Interdum et malesuada fames ac ante ipsum primis in faucibus. Suspendisse cursus venenatis urna sed malesuada. Mauris varius urna vitae molestie faucibus.';
  liked = true;
  likeCount = 12;
  commentCount = 5;
}
